module.exports = __webpack_public_path__ + "img/literary.5e85c1a5.jpg";